<template>
  <div class="common-page contour">
    <div class="common-left">
      <img class="logo" src="@assets/img/logo-login.png" alt="">
      <div class="icon">
        <img src="@assets/img/icon.svg" alt="">
      </div>
      <div class="border">
        <img src="@assets/img/login-bg.svg" alt="">
      </div>
    </div>
    <div class="common-box">
      <slot></slot>
    </div>
    <div class="common-footer">
      <p>版权所有 ©2014-2021 深圳维盟科技股份有限公司成都分公司.ALL RIGHTS RESERVED.</p>
      <p><a href="https://beian.miit.gov.cn" target="_blank">蜀ICP备17005920号-2</a></p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CommonPage",
  }
</script>

<style scoped lang="scss">
  .common-page {
    width: 100%;
    height: 100%;
    background: #fff;
    position: relative;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    .common-left {
      float: left;
      width: calc(100% - 700px);
      background-color: #d3efff;
      height: 100%;
      position: relative;
      margin-right: 100px;
      .logo {
        position: absolute;
        left: 60px;
        top: 20px;
        z-index: 9;
      }
      .icon {
        height: 100%;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 90%;
          min-width: 200px;
        }
      }
      .border {
        position: absolute;
        top: 0;
        bottom: 0;
        right: -100px;
        overflow: hidden;
      }
    }
    .common-box {
      display: inline-block;
      vertical-align: middle;
      max-width: 400px;
      width: 90%;
      position: relative;
      z-index: 99;
      box-sizing: border-box;
      padding: 30px 40px;
      border-radius: 5px;
      background-color: #fff;
    }
    @media screen and (max-width:550px){
      .common-left {
        display: none;
      }
      .common-box{
        padding: 30px 25px;
        /deep/ {
          .el-form {
            text-align: left;
            .el-form-item__label {
              float: none;
            }
            .el-form-item__content {
              margin: 0!important;
            }
          }
        }
      }
      .common-footer {
        display: none;
      }
    }
    .common-footer {
      text-align: center;
      position: absolute;
      color: #666;
      bottom: 0;
      left: 0;
      right: 0;
      font-size: 14px;
      line-height: 1.8;
      a {
        text-decoration: none;
        color: #666;
      }
    }
  }
</style>
